<ng-container *transloco="let t">
  <form [formGroup]="form">
    <div class="flex gap-s">
      <div class="recommended-analyses-wrapper">
        <h3>{{ t('Recommended analyses') }}</h3>
        <div class="recommended-analyses">
          <mat-checkbox appAutofocus
            class="example-margin"
            formControlName="recommendedHematology"
            >{{ t('Hematology') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedEkg"
            >{{ t('EKG') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedBiopsy"
            >{{ t('Biopsy') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedBiochemistry"
            >{{ t('Biochemistry') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedEho"
            >{{ t('EHO') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedEndoscopy"
            >{{ t('Endoscopy') }}</mat-checkbox
          >

          <mat-checkbox
            class="example-margin"
            formControlName="recommendedRtg"
            >{{ t('RTG') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedMri"
            >{{ t('MRI/CT') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="recommendedUrineAnalysis"
            >{{ t('Urine analysis') }}</mat-checkbox
          >
        </div>
        <mat-form-field
          class="example-full-width margin-top-s full-width"
          appearance="outline"
        >
          <mat-label>{{ t('Other') }}</mat-label>
          <input matInput formControlName="recommendedOther" />
        </mat-form-field>
      </div>
      <div class="performed-analyses-wrapper">
        <h3>{{ t('Performed analyses') }}</h3>
        <div class="performed-analyses">
          <mat-checkbox
            class="example-margin"
            formControlName="performedHematology"
            >{{ t('Hematology') }}</mat-checkbox
          >
          <mat-checkbox class="example-margin" formControlName="performedEkg">{{
            t('EKG')
          }}</mat-checkbox>
          <mat-checkbox
            class="example-margin"
            formControlName="performedBiopsy"
            >{{ t('Biopsy') }}</mat-checkbox
          >
          <mat-checkbox
            class="example-margin"
            formControlName="performedBiochemistry"
            >{{ t('Biochemistry') }}</mat-checkbox
          >
          <mat-checkbox class="example-margin" formControlName="performedEho">{{
            t('EHO')
          }}</mat-checkbox>
          <mat-checkbox
            class="example-margin"
            formControlName="performedEndoscopy"
            >{{ t('Endoscopy') }}</mat-checkbox
          >

          <mat-checkbox class="example-margin" formControlName="performedRtg">{{
            t('RTG')
          }}</mat-checkbox>
          <mat-checkbox class="example-margin" formControlName="performedMri">{{
            t('MRI/CT')
          }}</mat-checkbox>
          <mat-checkbox
            class="example-margin"
            formControlName="performedUrineAnalysis"
            >{{ t('Urine analysis') }}</mat-checkbox
          >
        </div>
        <mat-form-field
          class="example-full-width margin-top-s full-width"
          appearance="outline"
        >
          <mat-label>{{ t('Other') }}</mat-label>
          <input matInput formControlName="performedOther" />
        </mat-form-field>
      </div>
    </div>

    <mat-form-field
      style="width: 100%"
      appearance="outline"
      class="margin-top-s"
    >
      <mat-label>{{
        t('Brief description of the intervention / procedure')
      }}</mat-label>
      <textarea
        matInput
        rows="4"
        [formControlName]="'interventionProcedure'"
      ></textarea>
    </mat-form-field>

    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>{{ t('Notes and instructions') }}</mat-label>
      <textarea
        matInput
        rows="4"
        [formControlName]="'notesInstructions'"
      ></textarea>
    </mat-form-field>

    <div class="costs gap-s column">
      <div class="flex gap-s">
        <p>{{ t('Cost estimation of the mentioned procedures') }}</p>
        <div class="gap-s">
          <mat-form-field appearance="outline" class="hideError">
            <mat-label>{{ t('from the') }}</mat-label>
            <input
              matInput
              [formControlName]="'costEstimationMentionedProceduresFrom'"
              type="number"
              min="0"
            />
          </mat-form-field>
          -
          <mat-form-field appearance="outline" class="hideError">
            <mat-label>{{ t('to') }}</mat-label>
            <input
              matInput
              [formControlName]="'costEstimationMentionedProceduresTo'"
              type="number"
              min="0"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="flex gap-s">
        <p>{{ t('Subsequent costs') }}</p>
        <div class="gap-s">
          <mat-form-field appearance="outline" class="hideError">
            <mat-label>{{ t('from the') }}</mat-label>
            <input
              matInput
              [formControlName]="'additionalCostFrom'"
              type="number"
              min="0"
            />
          </mat-form-field>
          -
          <mat-form-field appearance="outline" class="hideError">
            <mat-label>{{ t('to') }}</mat-label>
            <input
              matInput
              [formControlName]="'additionalCostTo'"
              type="number"
              min="0"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="flex gap-s">
        <p>{{ t('Next review') }}</p>
        <div class="gap-s">
          <mat-form-field appearance="outline" class="hideError">
            <mat-label>{{ t('Date') }}</mat-label>
            <input
              matInput
              [matDatepicker]="datePicker"
              formControlName="date"
            
          [min]="minDate" [max]="today"
        />
            <mat-datepicker-toggle
              matSuffix
              [for]="datePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </form>
</ng-container>
